import { type FC, type PropsWithChildren } from 'react';

import { Footer, Header } from '../../components/base/ui';

const BaseLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex min-h-dvh flex-col items-center font-nunito bg-base-dark-gray-200 justify-center md:px-14 md:py-8">
      <div className="md:max-h-[768px] flex flex-col flex-grow md:gap-8 justify-between items-center w-full">
        <Header />
        {children}
        <Footer />
      </div>
    </div>
  );
};

export { BaseLayout };
